module.exports = __webpack_public_path__ + "img/hyj1.175868a6.png";